import { toast } from "react-toastify";
import stopwatchRepository from "../../services/stopwatchRepository";

// This could be your PWA installation button component
const InstallPWAButton = () => <button className="w-full text-left px-4 py-2 mt-2 hover:bg-neutral-100 dark:hover:bg-neutral-700 transition-colors rounded-lg text-neutral-700 dark:text-neutral-300">Install App</button>;

const DataManagement = () => {

    const handleClearData = () => {
        // In a real app, show a confirmation modal first!
        if (window.confirm("Are you sure? This will remove all local sessions and settings.")) {
            stopwatchRepository.clearAllSessions();
            console.log("Local data cleared.");
            toast.info("Local data cleared successfully.");
        }
    };

    const handleDeleteAccount = () => {
        // In a real app, show a confirmation modal first!
        if (window.confirm("Are you sure you want to delete your account? This action is irreversible.")) {
            console.log("Account deletion initiated.");
        }
    };

    return (
        <div className="bg-white dark:bg-neutral-800 rounded-lg p-6 shadow-sm">
            <h2 className="text-xl font-semibold text-neutral-800 dark:text-white mb-4">Data & App</h2>
            <div className="space-y-2">
                <InstallPWAButton />
                <button
                    onClick={handleClearData}
                    className="w-full text-left px-4 py-2 hover:bg-neutral-100 dark:hover:bg-neutral-700 transition-colors rounded-lg text-red-600 dark:text-red-500 font-medium">
                    Clear Local Data
                </button>
                <p className="text-xs text-neutral-500 dark:text-neutral-400 px-4">
                    Removes all stopwatch sessions from your device.
                </p>
                <button
                    onClick={handleDeleteAccount}
                    className="w-full text-left px-4 py-2 mt-4 hover:bg-neutral-100 dark:hover:bg-neutral-700 transition-colors rounded-lg text-red-600 dark:text-red-500 font-medium">
                    Delete Account
                </button>
                <p className="text-xs text-neutral-500 dark:text-neutral-400 px-4">
                    Permanently delete your account and all associated data.
                </p>
            </div>
        </div>
    );
};

export default DataManagement;
